import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { money } from './util'
import TipSelect from './TipSelect'
import payMobx from '@mobx/pay/pay.mobx'

interface IProps {
  tipFixed?: boolean;
  tip?: number;
  tipSelected?: boolean;
  onTipChange?(tip: number): void;
}

const OrderSummary: FC<IProps> = ({ tipFixed, tip, tipSelected, onTipChange }) => {
  if (!payMobx.order) return null

  const total = payMobx.order.subtotal + payMobx.order.tax + tip

  return (
    <>
      <div className='item'>
        <div className='name'>{i18n.t('pay.subtotal')}</div>
        <div className='value'>{money(payMobx.order.subtotal)}</div>
      </div>
      {payMobx.order.serviceCharge > 0 && (
        <div className='item'>
          <div className='name'>{i18n.t('pay.serviceCharge')}</div>
          <div className='value'>{money(payMobx.order.serviceCharge)}</div>
        </div>
      )}
      <div className='item'>
        <div className='name'>{i18n.t('pay.feeAndTax')}</div>
        <div className='value'>{money(payMobx.order.tax)}</div>
      </div>
      {tipFixed ? (
        <div className='item'>
          <div className='name'>{i18n.t('pay.tip')}</div>
          <div className='value'>{money(tip)}</div>
        </div>
      ) : (
        <div className='item select-tip'>
          <div className='name'>{i18n.t('pay.tip')}</div>
          <TipSelect tip={tip} tipSelected={tipSelected} onTipChange={onTipChange} />
        </div>
      )}
      <div className='total'>
        {i18n.t('pay.totalWithColon')}{money(total)}
      </div>
    </>
  )
}

export default observer(OrderSummary)
